<template lang="pug">
    v-card(v-if="loading")
        v-skeleton-loader(v-if="loading" type="card")
    v-card(v-else)
        v-card-subtitle Состав портфеля
        v-card-text(v-if="portfolioSectorsChartOptions && portfolioSeries")
            apexchart(type="donut" :options="portfolioSectorsChartOptions" :series="portfolioSeries").mb-5
            span Текущая доходность: {{ $store.state.client.userProfile.profitability.toFixed(2) }}%
</template>

<script>
  import VueApexCharts from 'vue-apexcharts';
  import ClientApi from '@/api/client'

  export default {
    name: 'PortfolioComposition',
    components: {
      'apexchart': VueApexCharts,
    },
    computed: {
      userPortfolio() {
        return this.$store.getters.portfolioForChart;
      },
      securitiesSectors() {
        return this.$store.getters.securities_sectors
      },
      chartColors() {
        let colors = []
        for (const s of this.userPortfolio.sectors){
          if (this.sectorColors[s.toLocaleLowerCase()]) {
            colors.push(this.sectorColors[s.toLocaleLowerCase()])
          }
        }
        return colors
      }
    },
    data() {
      return {
        loading: true,
        portfolioSectorsChartOptions: null,
        portfolioSeries: null,
        sectorColors: []
      };
    },
    async created() {
      await this.$store.dispatch('getClientPortfolio', this.$store.state.auth.user.id)
      this.sectorColors = await this.$store.getters.securities_sectors
      this.loading = false
      this.portfolioSectorsChartOptions = this.getPortfolioSectorsChartOptions()
      this.portfolioSeries = this.getSeries()
    },
    methods: {
      getPortfolioSectorsChartOptions() {
        return {
          chart: {
            width: 380,
            type: 'donut',
            animations: {
              enabled: false
            },
          },
          colors: this.chartColors,
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  total: {
                    show: true,
                    showAlways: true,
                    label: 'Total',
                    formatter: function (w) {
                      let total = w.globals.seriesTotals.reduce((a, b) => {
                        return a + b
                      }, 0)
                      var formatter = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 0
                      })
                      return formatter.format(total)
                    }
                  }
                },
              },
            },
          },
          labels: this.userPortfolio.sectors,
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                },
                legend: {
                  position: 'bottom',
                },
              },
            }],
        }
      },
      getSeries () {
        return this.userPortfolio.values
      },
      async getClientBalanceChanges () {
        let balanceChanges = await ClientApi.getClientBalanceChanges(this.$store.state.auth.user.id)
        return balanceChanges
      }
    },
  };
</script>

<style scoped>

</style>